import React, { memo } from "react";
import {
  FormControl,
  InputLabel,
  TextareaAutosize,
  FormHelperText,
  Grid
} from "@mui/material";
import useStyles from "./styles";
import PropTypes from "prop-types";
import classNames from "classnames";

interface ITextarea {
  id: string;
  label: string;
  value?: string | number | readonly string[];
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>
  onKeyPress?: React.KeyboardEventHandler<HTMLTextAreaElement>
  autoComplete?: string;
  disabled?: boolean,
  placeholder?: string;
  errorMessage?: string;
  customBodyPosition?: string;
  style?: Record<string, string>;
  required?: boolean;
  isTouched?: boolean;
  customLabelStyle?: string;
  minRows?: number;
}

const TextAreaInput = ({
  id,
  value,
  label,
  onChange,
  onKeyPress,
  autoComplete,
  placeholder,
  disabled = false,
  customBodyPosition,
  style = {},
  errorMessage,
  isTouched,
  customLabelStyle,
  required = false,
  minRows
}: ITextarea) => {
  const classes = useStyles();
  const isErrorOccurs = isTouched && errorMessage;

  return (
    <FormControl className={classNames(classes.formControl, customBodyPosition)}>
      <InputLabel
        required={required}
        className={classNames(
          customLabelStyle ? customLabelStyle : null,
          isErrorOccurs ? classes.errorLabel : null,
          classes.inputLabel
        )}
        shrink
        htmlFor={id}
      >
        {label}
      </InputLabel>
      <TextareaAutosize
        style={style}
        value={value}
        onChange={onChange}
        id={id}
        className={classes.textAreaInput}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
        onKeyPress={onKeyPress}
        data-testId={id}
        minRows={minRows}
      />
      {isErrorOccurs && (
        <Grid container>
          <FormHelperText
            data-testid={`errors-${id}`}
            className={
              classes.errorSpan
            }
          >
            {errorMessage}
          </FormHelperText>
        </Grid>
      )}
    </FormControl>
  );
};

TextAreaInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  autoComplete: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  errorMessage: PropTypes.string,
};

export default memo(TextAreaInput);
